import React, { Component } from 'react';
import { MultiDropdownList } from '@appbaseio/reactivesearch';
import MultiDropdownListWithFocus from './MultiDropdownListWithFocus';

class Warehouse extends Component {
  render() {
    return (
      <div className="warehouse">
        <MultiDropdownList
          title="Warehouse"
          className="form-field"
          componentId="Warehouse"
          dataField={"Warehouse.keyword"}
          renderListItem={label => (
            <div>{label !== "NULL" ? label : "None"}</div>
          )}
          size={100}
          showCount={false}
          showSearch={true}
          sortBy="asc"
        />
      </div>
    );
  }
}

export default MultiDropdownListWithFocus(Warehouse);